export class Point {
  visible_label: string; // label to show in the input field
  address: string;
  label: string;
  coordinates: Coordinates;
  type: string;
  isTemp: boolean;
  end: any;
  address_components: any[];
  id: number;
  comune: string;
  research_method?: string;
  street?: string;
  street_number?: string;
  cap?: any;
  provincia?: string;
  country?: string;
  indirizzo?: any;
}

export class Coordinates {
  lat: number;
  lng: number;
}
